<template>
    <div
      v-if="data.totalPages > 1"
      class="bbp-pagination"
      :class="{'bbp-pagination_sticky': sticky}"
    >
      <div class="bbp-pagination-item bbp-pagination-item_nav bbp-pagination-item_double"
           v-if="data.totalPages > 3"
           @click="clickPage(1)">
        <i class="bbp-icon-arrow bbp-pagination__nav bbp-pagination__nav_left"/>
        <i class="bbp-icon-arrow bbp-pagination__nav bbp-pagination__nav_left"/>
      </div>
      <div class="bbp-pagination-item bbp-pagination-item_nav"
           v-if="data.totalPages > 1"
           @click="clickPage(data.prevPage)">
        <i class="bbp-icon-arrow bbp-pagination__nav bbp-pagination__nav_left"/>
      </div>
      <div class="bbp-pagination-item"
           v-for="(page, index) in pages"
           :key="index + 'bb' + page"
           @click="clickPage(page, index)"
           :class="{
         'bbp-pagination-item_ellipsis': typeof page === 'string',
         'bbp-pagination-item_active': activePage === index
         }">
        {{page}}
      </div>
      <div class="bbp-pagination-item bbp-pagination-item_nav"
           v-if="data.totalPages > 1"
           @click="clickPage(data.nextPage)">
        <i class="bbp-icon-arrow bbp-pagination__nav bbp-pagination__nav_right"/>
      </div>
      <div class="bbp-pagination-item bbp-pagination-item_nav bbp-pagination-item_double"
           v-if="data.totalPages > 3"
           @click="clickPage(data.totalPages)">
        <i class="bbp-icon-arrow bbp-pagination__nav bbp-pagination__nav_right"/>
        <i class="bbp-icon-arrow bbp-pagination__nav bbp-pagination__nav_right"/>
      </div>
    </div>
</template>

<script>
export default {
  name: 'BBPPagination',
  props: ['data', 'getQuery', 'limit', 'sticky'],
  data () {
    return {
      activePage: 0,
      pages: [1, 2, 3]
    }
  },
  methods: {
    setPages ({totalPages, page, prevPage, nextPage}) {
      if (totalPages <= 3) {
        this.activePage = page - 1
        const firstPages = [1, 2, 3]
        this.pages = firstPages.splice(0, totalPages)
        return
      }
      if (prevPage && nextPage) {
        this.activePage = 1
        this.pages = [prevPage, page, nextPage, '...', totalPages]
      } else if (!prevPage && nextPage) {
        this.activePage = 0
        let checkPage
        totalPages === nextPage + 1 ? checkPage = totalPages : checkPage = nextPage + 1
        this.pages = [page, nextPage, checkPage, '...', totalPages]
      } else if (prevPage && !nextPage) {
        this.activePage = 2
        this.pages = [prevPage - 1, prevPage, page]
      }
      if (totalPages === nextPage) {
        this.activePage = 3
        this.pages = [1, '...', prevPage, page, nextPage]
      } else if (totalPages === page) {
        this.activePage = 4
        this.pages = [1, '...', prevPage - 1, prevPage, page]
      }
    },
    clickPage (page) {
      if (page === '...' || !page || this.data.page === page) {
        return
      }
      const query = {
        limit: this.limit,
        page: page
      }
      this.getQuery(query)
    }
  },
  watch: {
    data () {
      this.setPages(this.data)
    }
  },
  beforeMount () {
    if (this.data.length > 0) {
      this.setPages(this.data)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-pagination {
    @include global-font;
    position: relative;
    z-index: 1;
    display: flex;

    &_sticky {
      position: sticky;
      bottom: 0;
    }

    &-item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 35px;
      height: 35px;
      margin: 0 6px;
      cursor: pointer;
      border-radius: 6px;
      background: rgba($color-white, 0.67);
      transition: .2s;
      font-size: 14px;
      line-height: 16px;
      color: $color-accent;
      user-select: none;

      &_ellipsis {
        width: auto;
        background-color: transparent;
      }

      &_nav {
        background-color: transparent;
      }

      &_double {
        margin: 0;

        i {
          margin: -3px;
        }
      }

      &:last-child,
      &:first-child {
        margin: 0;
      }

      &:hover {
        box-shadow: 0 0 40px rgba($color-black, 0.1);
      }

      &_active {
        background-color: $color-accent;
        color: $color-white;
      }
    }

    &__nav {
      display: block;
      font-size: 8px;
      color: $color-accent;

      &_left {
        transform: rotate(90deg);
      }

      &_right {
        transform: rotate(270deg);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPPagination/BBPPagination.vue